import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cms",
  "use": "icon-cms-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-cms\"><path d=\"M96 160a64 64 0 0 1 64-64h704a64 64 0 0 1 64 64v704a64 64 0 0 1-64 64h-704a64 64 0 0 1-64-64v-704z m768 704v-704h-704v704h704zM512 544a160 160 0 1 0 0-320 160 160 0 0 0 0 320z m0-256a96 96 0 1 1 0 192 96 96 0 0 1 0-192z m224 440.32A478.272 478.272 0 0 0 512 672a478.272 478.272 0 0 0-224 56.32v71.68h-64v-73.088c0-22.208 11.456-43.136 31.104-53.632A542.72 542.72 0 0 1 512 608a542.72 542.72 0 0 1 256.896 65.28c19.648 10.496 31.104 31.36 31.104 53.632V800h-64v-71.68z\" fill-opacity=\".9\" p-id=\"1564\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cms.svg
// module id = fHET
// module chunks = 20